import Input, { GlobalInputProps } from 'components/common/Forms/Input';
import React, { ReactElement } from 'react';
import { FilterProps } from 'react-table';
import { useEffectOnce } from 'react-use';
import { FilterInputContainerStyleOverride } from './Table.styled';

type CustomInputProps = Omit<GlobalInputProps, 'name'> & { name?: string };

interface Props extends FilterProps<object> {
  inputProps?: CustomInputProps;
}

export default function DefaultInputFilter({
  column: { filterValue, setFilter, id },
  inputProps,
}: Props): ReactElement {
  const inputName = inputProps?.name || id;
  useEffectOnce(() => {
    if (inputProps?.defaultValue) {
      setFilter(inputProps.defaultValue);
    }
  });
  return (
    <Input
      {...inputProps}
      noSpaceForHelperText
      id={id}
      value={filterValue || ''}
      name={inputName}
      containerStyle={FilterInputContainerStyleOverride}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
    />
  );
}
